import styles from '../Disco.module.css';
import { useTheme } from '../../../../../../hooks/useTheme';
import Button from '../../../../../ui/Button/BlockButton';
import { AdContent } from './AdContent';
import { BannerMedia } from './BannerMedia';
import { PILL_BUTTON_STYLE, type BannerOfferContent } from './BannerOffer';
import { StoryBars } from './StoryBars';
import type { BannerNavControl } from '../bannerFormat';

interface BannerInlineCardProps {
  offer: BannerOfferContent;
  index: number;
  total: number;
  onPrev: (control: BannerNavControl) => void;
  onNext: (control: BannerNavControl) => void;
  onAccept: () => void;
  onDecline: () => void;
  onImageError?: (imageUrl: string) => void;
  widgetRef: React.RefCallback<HTMLDivElement>;
  adRef: React.RefCallback<HTMLDivElement>;
}

export function BannerInlineCard({
  offer,
  index,
  total,
  onPrev,
  onNext,
  onAccept,
  onDecline,
  onImageError,
  widgetRef,
  adRef,
}: BannerInlineCardProps) {
  const theme = useTheme();

  return (
    <div
      ref={widgetRef}
      data-testid="banner-inline-card"
      className={styles.inlineBanner}
      style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}
    >
      <div className={styles.inlineBannerHead}>
        <StoryBars index={index} total={total} />
        <div className={styles.inlineBannerBrandRow}>
          <div className={styles.inlineBannerBrand}>
            {offer.logoUrl && (
              <div className={styles.inlineBannerLogo}>
                <img src={offer.logoUrl} alt="" />
              </div>
            )}
            <span className={styles.inlineBannerName}>
              {offer.advertiserName}
            </span>
          </div>
          <span className={styles.sponsoredBadge}>Sponsored</span>
        </div>
      </div>
      <div ref={adRef}>
        <BannerMedia
          key={offer.offerId}
          variant="inline"
          imageUrl={offer.heroImageUrl}
          fillColor={theme.buttonsPrimaryDefault?.backgroundColor ?? '#0f1217'}
          index={index}
          total={total}
          showArrows
          tapToNavigate={false}
          onPrev={onPrev}
          onNext={onNext}
          onImageError={onImageError}
        />
        <div className={styles.inlineBannerCopy}>
          <p
            className={styles.inlineBannerTitle}
            style={{
              fontFamily: theme.headersMediumNone?.fontFamily,
              color: theme.headersMediumNone?.color,
            }}
          >
            {offer.heading}
          </p>
          <AdContent
            subheading={offer.subheading}
            disclosureDetails={offer.disclosureDetails}
            jsonContent={offer.jsonContent}
            bodyStyle={theme.bodytextDefaultNone}
          />
        </div>
      </div>
      <div className={styles.inlineBannerActions}>
        <Button big onClick={onAccept} style={PILL_BUTTON_STYLE}>
          {offer.acceptCopy}
        </Button>
        <button
          type="button"
          className={styles.inlineBannerDecline}
          onClick={onDecline}
        >
          {offer.declineCopy}
        </button>
      </div>
    </div>
  );
}
